import {
    computed, observable, makeObservable,
} from 'mobx';
import { Axios } from '../utilities/network';
import { isWeb } from '../utilities/platform';
import RootStore from './root-store';
import { navigate } from 'gatsby';
import { PAGE_SIZE, UserInfo, VmList } from '../constants/options';
import { SetLocalStorage } from '../utilities/cryptography';

export default class ExamStore {

    loading: boolean = false;
    loadingInfo: boolean = false;
    updating: boolean = false;
    deleting: boolean = false;


    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        makeObservable(this, {
            loading: observable,
            loadingInfo: observable,
            updating: observable,
            deleting: observable,
        });
        this.rootStore = rootStore;
    }

    // searchApartmentList = async (skip: number, take: number, userModel: any = {}) => {
    //     this.loading = true;
    //     try {
    //         const res = await Axios.post(`/api/Apartment/Search/${skip}/${take}`, userModel);
    //         this.apartments = res.data;
    //         // console.log("Apartment List", res.data);
    //         return Promise.resolve(res.data);
    //     } catch (err) {
    //         return Promise.reject(err);
    //     } finally {
    //         this.loading = false;
    //     }
    // };
    getExamById = async (id: string) => {
        this.loadingInfo = true;
        try {
            const res = await Axios.get(`/api/Exam/${id}`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loadingInfo = false;
        }
    };

    deleteExam = async (id: string) => {
        this.deleting = true;
        try {
            const res = await Axios.delete(`/api/Exam/${id}`);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.deleting = false;
        }
    };

    updateExam = async (id: string, model: any) => {
        this.updating = true;
        try {
            const res = await Axios.put(`/api/Exam`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.updating = false;
        }
    };

    createExam = async (model: any) => {
        this.loading = true;
        try {
            const res = await Axios.post(`/api/Exam`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

    searchExams = async (model: any, skip: number, take: number) => {
        this.loading = true;
        try {
            const res = await Axios.post(`/api/Exam/Search/${skip}/${take}`, model);
            return Promise.resolve(res.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            this.loading = false;
        }
    };

}
